export default "__VITE_ASSET__C1YKGN2A__"